export const featureFlags = {
  pertamina: {
    isPhase2Enabled: process.env.PERTAMINA_PHASE_2 === 'true',
  },
  intelligence: {
    adjPoiPopup: process.env.ADJ_POPUP_POI === 'true',
    newParsetPoi: process.env.NEW_PARSET_POI === 'true',
    newDatexPoi: process.env.NEW_DATEX_POI === 'true',
  },
};
